type GetProvidersMedicalGuideParams = {
	dsEspecialidade?: string;
	cd_procedimento?: string;
	cdUf?: string;
	nmCidade?: string;
	coordenadas?: string;
	dsTipo: string;
	nmPrestador?: string;
	retornoAgrupado: boolean;
	tpRede?: number;
	signal?: AbortSignal;
	distancia?: string;
};

type ProvidersMedicalQualifications = {
	cdTipoQualificacao: number;
	dsTipoQualificacao: string;
	dsEspecialidade: string;
};

type ProvidersMedicalModalities = {
	consulta: string;
	internacao: string;
	maternidade: string;
};

enum NetworkTypeEnum {
	ALL = 0,
	SELF_NETWORK = 1,
	ACCREDITED_NETWORK = 2,
}

type AppointmentHour = {
	nmDiaSemana: string;
	hrInicialPrimeiroTurno: string | null;
	hrFinalPrimeiroTurno: string | null;
	hrInicialSegundoTurno: string | null;
	hrFinalSegundoTurno: string | null;
};

type ProvidersMedicalGuide = {
	codigo: number;
	nmPrestador: string;
	logradouro: string;
	dsComplEndereco: string | null;
	nmBairro: string;
	nmCidade: string;
	cdUf: string;
	tipo: string;
	tipoConsulta: string;
	tipoRede?: NetworkTypeEnum;
	nuTelefone: string;
	tipoPessoa: number;
	site: string;
	qualificacoes: ProvidersMedicalQualifications[];
	modalidade: ProvidersMedicalModalities | null;
	crmcnes: string | null;
	cep: string;
	cgccpf: string;
	nmFantasia: string;
	nmLocal: string | null;
	distancia: number;
	ordemRR: number | null;
	horariosAtendimento: AppointmentHour[] | null;
};

type GetProvidersMedicalGuideModel = {
	prestadores: ProvidersMedicalGuide[];
	telemedicina?: ProvidersMedicalGuide[];
	redePropria?: ProvidersMedicalGuide[];
	redeCredenciada?: ProvidersMedicalGuide[];
};

interface GetProvidersMedicalGuide {
	get: (params: GetProvidersMedicalGuideParams) => Promise<GetProvidersMedicalGuideModel>;
}

export type {
	GetProvidersMedicalGuideParams,
	ProvidersMedicalModalities,
	ProvidersMedicalGuide,
	GetProvidersMedicalGuideModel,
	GetProvidersMedicalGuide,
	AppointmentHour,
};

export {NetworkTypeEnum};
